<ng-container *transloco="let t;">
  <div class="layout-topbar" role="region" aria-label="{{ t('common.labels.header') }}">
      <div class="topbar-left">
          <a tabindex="0" class="menu-button" (click)="app.onMenuButtonClick($event)" (keyup.enter)="app.onMenuButtonClick($event)" pTooltip="{{ t('common.labels.toggle_menu') }}" aria-label="{{ t('common.labels.toggle_menu') }}">
            <i class="pi pi-chevron-left"></i>
          </a>
          <span class="topbar-separator"></span>
          <ng-template ngFor let-item let-last="last" [ngForOf]="items">
              <span class="viewname" style="text-transform: uppercase">{{item.label}}</span>
          </ng-template>
          <span *ngIf="sysMode === 'planner'">
            <button withRight="admin.planning-orders.order" pButton (click)="gotoNewOrder()" [label]="t('common.labels.new_order')"></button>
            <button withRight="admin.planning-orders.create" pButton (click)="gotoFreeOrder()" class="p-button-outlined p-button-secondary p-ml-2 p-mr-2" [label]="t('common.labels.free_order')"></button>
          </span>
          <span *ngIf="(billing.ending$ | async) === true" class="warning">
            <i class="pi pi-exclamation-triangle p-mr-2"></i> {{ t('common.labels.billing') }}: {{ t('billing.messages.ending', { amount: (billing.remaining$ | async)}) }}
          </span>
          <span *ngIf="(billing.depleted$ | async) === true" class="error">
            <i class="pi pi-exclamation-triangle p-mr-2"></i> {{ t('common.labels.billing') }}: {{ t('billing.messages.depleted') }}
          </span>
      </div>

      <div class="topbar-right">
          <ul class="topbar-menu" role="menu">
              <li class="profile-item" [ngClass]="{'active-menuitem fadeInDown': app.topbarUserMenuActive}" role="menuitem">
                  <a href="#" (click)="app.onTopbarUserMenuButtonClick($event)" (keyup.enter)="app.onTopbarUserMenuButtonClick($event)">
                      <span class="profile-name p-pl-2">{{ userName }}</span>
                  </a>
                  <ul class="profile-menu fade-in-up" role="menu">
                      <li role="menuitem">
                          <a (click)="gotoProfile()" (keyup.enter)="gotoProfile()" role="link" tabindex="0">
                              <i class="pi pi-user"></i>
                              <span>{{ t('topbar.labels.my_profile') }}</span>
                          </a>
                      </li>
                      <li role="menuitem" *ngIf="sysMode === 'planner' && hasAvailabilities()">
                          <a (click)="gotoAvailabilities()" (keyup.enter)="gotoAvailabilities()" role="link" tabindex="0">
                              <i class="pi pi-calendar"></i>
                              <span>{{ t('topbar.labels.availabilities') }}</span>
                          </a>
                      </li>
                      <li role="menuitem">
                          <a (click)="logout()" (keyup.enter)="logout()" role="link" tabindex="0">
                              <i class="pi pi-power-off"></i>
                              <span>{{ t('topbar.labels.logout') }}</span>
                          </a>
                      </li>
                  </ul>
              </li>
          </ul>
      </div>
  </div>
</ng-container>
